import * as React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TableRowProps } from '../admin-banners.type';

export const TableRow = (props: TableRowProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props['data-row-key'],
    });

    const style: React.CSSProperties = {
        ...props.style,
        transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
        transition,
        touchAction: 'manipulation',
        backgroundColor: 'white',
        ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
    };

    return (
        <tr
            ref={setNodeRef}
            style={style}
        >
            {React.Children.map(props.children, (child, index) => {
                if (index === 0) {
                    return React.cloneElement(child as React.ReactElement, {
                        children: (
                            <span
                                style={{
                                    cursor: 'move',
                                }}
                                {...listeners}
                                {...attributes}
                            >
                                ☰
                            </span>
                        ),
                    });
                }
                return child;
            })}
        </tr>
    );
};
